import React from 'react'
import cx from 'classnames'
import { useAppSelector } from 'reduxTyped'
import { Icon, IconComponent, l, Modal } from '@manychat/manyui'

import { NodeType } from 'common/builder/constants/NodeType'
import nodeRegistry from 'common/builder/nodeRegistry'
import * as nextStepSelectors from 'common/builder/selectors/builder/nextStepSelectors'
import { Col, Row } from 'components/Grid'
import { newOnboardingService } from 'utils/services/newOnboardingService'

import cm from './NodePicker.module.css'

interface INodePickerProps {
  builderId: string
  sourceId: string
  onSelect: (nodeId: string) => void
  onClose: () => void
  open: boolean
}

const ManyUIIcon = Icon as Record<string, IconComponent>

const RowClassNameMapping: Partial<Record<NodeType, string>> = {
  [NodeType.ACTION_GROUP]: cm.actionGroup,
  [NodeType.CONTENT]: cm.content,
  [NodeType.GOTO]: cm.goTo,
}

const NodePicker = (props: INodePickerProps) => {
  const { onSelect, onClose, open, builderId, sourceId } = props

  const items = useAppSelector((state) =>
    open ? nextStepSelectors.getNodesAllowedToConnect(state, builderId, sourceId) : [],
  )
  const isDisableEscapeClose = newOnboardingService.isAnyOnboardingRunning()

  return (
    <Modal
      className={cm.modal}
      open={open}
      onRequestClose={onClose}
      title={l.translate('Select a Step')}
      disableEscapeClose={isDisableEscapeClose}
    >
      <div className="p-a-md">
        {!items.length && (
          <div className="text-center text-secondary text-md">{l.translate('Nothing here')}</div>
        )}

        {items.map((item) => {
          const nodeConfig = nodeRegistry.get(item)
          const rowClassName =
            Boolean(item.nodeType) && item.nodeType in RowClassNameMapping
              ? RowClassNameMapping[item.nodeType]
              : ''

          return (
            <Row
              data-test-id={`existing-step`}
              data-onboarding-id="existing-step"
              key={item.id}
              middle
              onClick={() => onSelect(item.id)}
              className={cx(cm.nodeItem, rowClassName, 'm-b-xs')}
            >
              <Col width={75}>
                <div className={cx('text-center', cm.icon)}>
                  {React.createElement(ManyUIIcon[nodeConfig.icon], {
                    color: nodeConfig.color,
                    size: 32,
                  })}
                </div>
              </Col>
              <Col>
                <div className="text-subheading">{item.caption}</div>
              </Col>
            </Row>
          )
        })}
      </div>
    </Modal>
  )
}

export default NodePicker
